import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    gap: theme.spacing.space12,
    overflowX: "scroll",
    position: "relative",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  button: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space12}px`,
    borderRadius: theme.radius.small,
    background: theme.colors.background4,
    color: theme.colors.text2,
    border: `1.5px solid transparent`,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    "&.active": {
      borderRadius: theme.spacing.space8,
      border: `1.5px solid ${theme.colors.primary}`,
    },
  },
}));
